import Helper from './Helper';
import Gallery from './Gallery';
import LinkTargetHandler from './LinkTargetHandler';

class Lightbox {
  constructor(config = {}) {
    const {
      toggleSelector,
      isImageLightbox
    } = config;

    this.isImageLightbox = isImageLightbox;
    this.lightbox = document.querySelector('.lightbox');
    this.lightboxContent = document.querySelector('.lightbox__container');
    this.lightboxBackdrop = document.querySelector('.lightbox__backdrop');
    this.lightboxClose = document.querySelector('.lightbox__close-btn');
    this.toggle = document.querySelectorAll(toggleSelector);
    this.toggleArray = Array.prototype.slice.call(this.toggle);
    this.orientation = '';

    if(this.toggle && this.lightboxBackdrop){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.toggleArray.forEach(toggle => {
      toggle.addEventListener('click', e => {
        if(this.isImageLightbox){
          if(Helper.isDesktop()){
            this.addImageToLightbox(toggle);
          }
        } else{
          this.addInsightToLightbox(toggle);
        }
        //open lightbox only when is imageLightbox and on mobile
        if(this.isImageLightbox && !Helper.isDesktop()){
          return;
        }else{
          this.openLightbox();
        }
      });
    });

    this.lightboxBackdrop.addEventListener('click', e => {
      this.closeLightbox();
    });

    this.lightboxClose.addEventListener('click', e => {
      this.closeLightbox();
    });

    document.addEventListener('keyup', e => {
      if (e.keyCode == 27) {
        this.closeLightbox();
      }
    });
  }

  addInsightToLightbox(el){
    this.lightboxContent.innerHTML = Helper.unescapeHTML(el.querySelector('.insight-teaser__content').value);
    window.dispatchEvent(new Event('scroll'));
    new LinkTargetHandler({
      linkSelector: '.js-target-blank a'
    });
  }

  addImageToLightbox(el){
    const copy = el.cloneNode(true);
    const img = el.querySelector('img');
    this.orientation = Helper.imageOrientation(img);

    this.lightboxContent.appendChild(copy);
    Helper.addClass(this.lightbox, `image-lightbox`);
    Helper.addClass(this.lightbox, `image-lightbox--${this.orientation}`);
  }

  openLightbox(){
    Helper.addClass(document.querySelector('body'), 'lightbox-open');
    Helper.addClass(this.lightbox, 'lightbox--is-visible');
    setTimeout(()=>{
      Helper.addClass(this.lightbox, 'lightbox--is-visible-animation');
    }, 300);
    new Gallery({
      galleryContainerSelector: '.lightbox .ns-gallery',
    });
  }

  closeLightbox(){
    Helper.removeClass(document.querySelector('body'), 'lightbox-open');
    Helper.removeClass(this.lightbox, 'lightbox--is-visible-animation');
    setTimeout(()=>{
      Helper.removeClass(this.lightbox, 'lightbox--is-visible');
      this.lightboxContent.innerHTML = '';
    }, 300);
    Helper.removeClass(this.lightbox, `image-lightbox`);
    Helper.removeClass(this.lightbox, `image-lightbox--${this.orientation}`);
  }

}

export default Lightbox;
